/**
 * MEICET Skin Analysis Test Report — field definitions.
 *
 * Pure data. Lives outside `@/lib/LongevityEngine` (locked Engine file).
 * Shared by the upload/review dialog, the report view, the radar chart and
 * the trend charts so a label is only ever written once.
 */

export const DETECTION_ITEMS = Object.freeze([
  { key: "sensitivity", label: "Sensitivity" },
  { key: "spots", label: "Spots" },
  { key: "wrinkles", label: "Wrinkles" },
  { key: "pores", label: "Pores" },
  { key: "uv_spots", label: "UV Spots" },
  { key: "porphyrins", label: "Porphyrins" },
]);

export const SEVERITY_OPTIONS = Object.freeze(["Mild", "Moderate", "Severe"]);

export const SEVERITY_TONE = Object.freeze({
  Mild: { fg: "#1f6b4d", bg: "#dff0e6", stars: 1 },
  Moderate: { fg: "#8a5a1c", bg: "#fae3cc", stars: 2 },
  Severe: { fg: "#8f2f2f", bg: "#f8dada", stars: 3 },
});

/** Numeric fields the review screen can edit, in display order. */
export const SKIN_NUMERIC_FIELDS = Object.freeze([
  { key: "comprehensive_score", label: "Comprehensive Score", unit: "/ 100" },
  { key: "skin_age", label: "Skin Age", unit: "years" },
]);

export const SKIN_TREND_METRICS = Object.freeze([
  { key: "comprehensive_score", label: "Comprehensive Score", unit: "", color: "#b67358" },
  { key: "skin_age", label: "Skin Age", unit: "years", color: "#4b5f8c" },
]);

export const skinValue = (report, key) => {
  const v = report?.values?.[key];
  return v === undefined ? null : v;
};

export const detectionPercent = (report, key) => {
  const v = report?.detections?.[key]?.percent;
  return v === undefined ? null : v;
};

/** Recharts radar needs one row per axis. */
export const radarData = (report) =>
  DETECTION_ITEMS.map((d) => ({
    item: d.label,
    key: d.key,
    percent: detectionPercent(report, d.key) ?? 0,
    severity: report?.detections?.[d.key]?.severity || null,
    measured: detectionPercent(report, d.key) !== null,
  }));
